<template>
  <vue-tags-input class="tags-input"
              :element-id="fieldKey"
              add-tags-on-comma
              add-tags-on-blur
              placeholder=""
              :maxlength="maxlength"
              v-model="array"
              :wrapper-class="`form-tags form-control ${inputActiveClass}`"
              :disabled="disabled"
              @initialized="$emit('initialized')"
              @focus="active = true"
              @tags-updated="$emit('tags-updated')"
              @blur="onBlur"></vue-tags-input>
</template>

<script>
const VueTagsInput = () => import('@/components/input/vue-tagsinput');

export default {
  name: "TagsInput",
  components: {VueTagsInput},
  props: {
    disabled: Boolean,
    value: Array,
    fieldKey: String,
    maxlength: [Number, String]
  },
  data() {
    return {
      active: false,
      array: []
    }
  },
  methods: {
    onBlur() {
      this.active = false;
      this.$emit('blur');
    }
  },
  computed: {
    inputActiveClass() {
      return this.active ? 'active' : '';
    }
  },
  watch: {
    value(newVal) {
      this.array = newVal;
    },
    array(newVal) {
      if (!this.disabled) {
        this.$emit('input', newVal);
      }
    }
  }
}
</script>

<style scoped>

.tags-input >>> .form-tags.form-control.active {
  border-color: var(--accent-color) !important;
}

.tags-input >>> .form-tags.form-control.active {
  border-color: var(--accent-color) !important;
}

.tags-input >>> .form-tags.form-control {
  height: unset;
  min-height: calc(2.95rem + 2px);
}

.tags-input >>> .tags-input-badge {
  white-space: normal;
  text-align: left;
}
</style>
